import { IPaging } from "models/interfaces";
import React from "react";

const PageBtn: React.FC<{
  text: string | number;
  disp?: boolean;
  toPage?: number;
  className?: string;
  isIcon?: boolean;
  onChange?: (page: number) => void;
}> = (props) => {
  if (props.disp && props.toPage) {
    return (
      <button
        className={`px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-blue-300 hover:text-white ${props.className || ""}`}
        onClick={() => {
          if (props.onChange && props.toPage) {
            props.onChange(props.toPage);
          }
        }}
      >
        {props.text}
      </button>
    );
  } else {
    // return <button className="invisible">{props.text}</button>;
    return (
      <div className={`px-4 py-2  rounded-md cursor-default text-white ${props.isIcon ? "bg-gray-200" : "bg-blue-400"}`}>{props.text}</div>
    );
  }
};

type PROPS = {
  page: number;
  data: IPaging;
  onChange?: (page: number) => void;
};

const Pagination: React.FC<PROPS> = (props) => {
  const page = props.page;
  const paging = props.data.paging;
  const max = paging.max_page_no;
  const onCng = props.onChange;

  return (
    <div className="flex gap-2">
      <PageBtn isIcon className="font-bold" text="<<" disp={page > 1} toPage={1} onChange={onCng} />
      <PageBtn isIcon className="font-bold" text="<" disp={page > 1} toPage={page - 1} onChange={onCng} />
      <div className="flex items-center space-x-1">
        {page - 3 > 0 && <PageBtn text="1" disp={true} toPage={1} onChange={onCng} />}
        {page - 4 > 0 && <div className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md cursor-default">...</div>}
        {page - 2 > 0 && <PageBtn text={page - 2} disp={true} toPage={page - 2} onChange={onCng} />}
        {page - 1 > 0 && <PageBtn text={page - 1} disp={true} toPage={page - 1} onChange={onCng} />}
        <PageBtn text={page} />
        {page + 1 <= max && <PageBtn text={page + 1} disp={true} toPage={page + 1} onChange={onCng} />}
        {page + 2 <= max && <PageBtn text={page + 2} disp={true} toPage={page + 2} onChange={onCng} />}
        {page + 4 <= max && <div className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md cursor-default">...</div>}
        {page + 3 <= max && <PageBtn text={max} disp={true} toPage={max} onChange={onCng} />}
      </div>
      <PageBtn isIcon className="font-bold" text=">" disp={page < max} toPage={page + 1} onChange={onCng} />
      <PageBtn isIcon className="font-bold" text=">>" disp={page < max} toPage={max} onChange={onCng} />
    </div>
  );
};

export default Pagination;
